// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drop-down{position:relative}.drop-down.open button:after{transform:rotate(180deg)}.drop-down.open .menu{display:inline-block}.drop-down button{border:none;background:transparent}.drop-down button .image{width:40px}.drop-down .content{display:flex;flex-direction:column;padding:14px 18px 18px;background:#fff;box-shadow:0 4px 20px rgba(32,0,51,.1);border-radius:20px;text-align:left;position:absolute;z-index:1;right:5px;top:42px}", ""]);
// Exports
module.exports = exports;
